"use client";

import { useUser } from "@clerk/nextjs";
import Link from "next/link";
import Image from "next/image";
import { Settings, User } from "lucide-react";
import { useSettings } from "@/components/settings/SettingsProvider";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  MY_DASHBOARD_HOME,
  MY_DASHBOARD_HOME_ICON,
  MY_DASHBOARD_HOME_LABEL,
  MY_NAV_ITEMS,
} from "@/app/my/my-nav";

export default function CustomUserButton({
  showCustomMenuItems = true,
}: {
  showCustomMenuItems?: boolean;
}) {
  const { user, isSignedIn } = useUser();
  const { openSettings } = useSettings();
  if (!isSignedIn) return null;
  const avatar = (
    <button
      type="button"
      aria-label={showCustomMenuItems ? "내 메뉴 열기" : "계정 설정 열기"}
      onClick={showCustomMenuItems ? undefined : () => openSettings("account")}
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {user.imageUrl ? (
        <Image
          unoptimized
          src={user.imageUrl}
          alt=""
          width={30}
          height={30}
          className="h-[30px] w-[30px] rounded-full"
        />
      ) : (
        <User className="h-5 w-5" aria-hidden />
      )}
    </button>
  );
  if (!showCustomMenuItems) return avatar;
  const DashboardIcon = MY_DASHBOARD_HOME_ICON;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{avatar}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60" data-rail-floating-ui>
        <DropdownMenuItem asChild>
          <Link href={MY_DASHBOARD_HOME}>
            <DashboardIcon className="h-4 w-4" aria-hidden />
            {MY_DASHBOARD_HOME_LABEL}
          </Link>
        </DropdownMenuItem>
        {MY_NAV_ITEMS.map((item) => (
          <DropdownMenuItem key={item.href} asChild>
            <Link href={item.href}>
              <item.icon className="h-4 w-4" aria-hidden />
              {item.label}
            </Link>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => openSettings("account")}>
          <Settings className="h-4 w-4" aria-hidden />
          설정 및 계정 관리
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
